import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/',
        exact: true,
        auth: true,
        isForDealerCabinet: true,
        component: loadable({
            loader: () => import('./pages/cabinet/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/dealer/order/:id/:section?',
        exact: true,
        auth: true,
        isForDealerCabinet: true,
        component: loadable({
            loader: () => import('./pages/orderView/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
